import Http from '../http'

// 登录模块API
export default {
  // 登录二级账号
  login (params) {
    return Http.post('/user/login.do', params)
  },
  // 登录admin账号
  loginAdmin (params) {
    return Http.post('/sys/login.do', params)
  },
  // 退出
  logout () {
    return Http.post('/logout.do')
  },
  // 修改admin密码
  modifyAdminPs (params) {
    return Http.post('/sys/sysPwd.do', params)
  },
  // 修改非admin账号密码
  modifySecPs (params) {
    return Http.post('/login/loginPwd.do', params)
  },
  getInformation () {
    return Http.post('/user/information.do')
  },
  directLogin (params) {
    return Http.post('/login/session.do', params)
  },
  heartbeat () {
    return Http.post('/heartbeat.do')
  },
  // 首次登陆修改密码
  modifyPsFirstLogin (params) {
    return Http.post('/login/updateLoginPwd', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/login.js